import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LeasingFormFields } from "web_myplann/Portfolio/Forms/LeasingForm/LeasingFormFields";
import { useEditLeasingForm } from "web_myplann/Portfolio/Forms/LeasingForm/useEditLeasingForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditLeasingFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditLeasingForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditLeasingFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } = useEditLeasingForm({
		portfolioId,
		portfolio,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<LeasingFormFields
				control={form.control}
				namePlaceholder={t(Resources.Portfolio.EditPortfolio.Placeholders.name)}
				contractNumberPlaceholder={t(
					Resources.Portfolio.EditPortfolio.Placeholders.contractNumber,
				)}
			/>
		</PortfolioFormShell>
	);
};
